export class Constants {
  static sound: HTMLAudioElement;
  static playingTrack: string;
  static audioWindow: any;
  static mapPlayList = new Map();
  static DAYS_TO_ENTRY_SERVICE: number = 30;
  static SERTYPE_ADULT: string = "02";
  static SERTYPE_YOUNG: string = "03";
  static SERTYPE_TEEN: string = "04";
  static SERTYPE_CHILDS: string = "05";
  static SERTYPE_MARRIAGE: string = "06";
  static SERTYPE_SCHOOL_1ET: string = "16";
  static SERTYPE_SCHOOL_2ET: string = "17";
  static SERTYPE_SCHOOL_3ET: string = "18";
  static GUIDE_TYPE: string = "G";
  static GUIDE_FUTURE_TYPE: string = "F";
  static GUIDE__TYPE_OTHER: string = "O"

  static USER__TYPE_GUI_FG: string = "Nrm"
  static USER__TYPE_ADMIN: string = "Adm"
  static USER__TYPE_SUPPLIER: string = "Prv"

  static LOCAL_LEVELID: string = 'L';
  static NATIONAL_LEVELID: string = 'N';
  static ZONE_LEVELID: string = 'Z';
  static INTNAL_LEVELID: string = 'I';

  static INTNAL_STOREID: string = "0000000002";

  static FUNCT_COORD: string = 'C';
  static FUNCT_SECRE: string = 'S';
  static FUNCT_TREAS: string = 'T';
  static FUNCT_MATE: string = 'M';
  static FUNCT_YOUNG: string = 'Y';
  static FUNCT_EEPPG: string = 'P';


  static ERRORSTATUS: string = 'ERROR';
  static ERRORRECORDEXIST: string = 'RECORDEXIST';
  static OKSTATUS: string = 'OK';
  static EXCEPTION_ERROR: string = 'EXCPERROR';

  static CANCEL_DELETE_STATUS: string = "X";

  static WEB_RESPO_DEVICE_ID: string = "1";
  static APP_DEVICE_ID: string = "2";
  static ELECTOV_DEVICE_ID: string = "3";
  static WEB_MONO_DEVICE_ID: string = "4";
  static APP_USA: string = "USA";
  static SGO_BRAZIL: string = "BR";

  static SUCCESS_MESSAGE = "La información se ha obtenido exitosamente.";
  static FAILED_MESSAGE = "Hubo un incidente al obtener la información, intentelo más tarde.";
  static NEW_STATUS = 'N';

  static sellTypeLPC: string = "C";// COV
  static sellTypeSPG: string = "F";// future Guides
  static sellTypeGUI: string = "G";// Guides
  static sellTypePUB: string = "P";// Public

  //
  static selStore: any = null;
  static itemsNavigation: any = null;
  static cookie_Name="tovpilApp";
}